<template>
    <v-text-field
      :value="balance"
      @input="$emit('update:balance', $event)"
      type="number"
      :label="`Balance (${displayMode})`"
      single-line
      clearable
      hide-details
      :append-outer-icon="toggleIcon"
      @click:append-outer="toggleMode"
      style="max-width: 140px;"
    >
      <template #append-outer>
        <v-btn
          icon
          small
          @click.stop="toggleMode"
          :title="toggleTitle"
        >
          <v-icon>{{ toggleIcon }}</v-icon>
        </v-btn>
      </template>
    </v-text-field>
  </template>
  
  <script>
  export default {
    name: "BalanceFilterField",
    props: {
      balance: { type: Number, default: 0 },
      mode: { type: String, default: "above" }, // "above" or "below"
    },
    emits: ["update:balance", "update:mode"],
    computed: {
      toggleIcon() {
        return this.mode === "above" ? "mdi-greater-than-or-equal" : "mdi-less-than-or-equal";
      },
      displayMode() {
        return this.mode === "above" ? "≥" : "≤";
      },
      toggleTitle() {
        return this.mode === "above" ? "Φίλτρο: Υπόλοιπο μεγαλύτερο ή ίσο" : "Φίλτρο: Υπόλοιπο μικρότερο ή ίσο";
      }
    },
    methods: {
      toggleMode() {
        this.$emit("update:mode", this.mode === "above" ? "below" : "above");
      }
    }
  };
  </script>